/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

export function initForms() {
  const forms = Array.from(document.querySelectorAll('.form')) as HTMLElement[]

  for (const form of forms) {
    if (form.dataset.hydrated) continue
    form.dataset.hydrated = 'true'

    const firstInput = form.querySelector('input, select, textarea') as
      | HTMLElement
      | null

    const formIsInDialog = form.closest('dialog') !== null

    if (firstInput && formIsInDialog) {
      firstInput.setAttribute('autofocus', 'true')
    }

    form.addEventListener('set-loading', () => {
      form.classList.add('form--loading')
    })

    form.addEventListener('unset-loading', () => {
      form.classList.remove('form--loading')
    })
  }
}
